import { root } from './go-live';
import * as idEndpoints from './id';

export const goLive = {
  ...root,
  id: {
    ...idEndpoints,
  },
};
